<template >
  <div
    class="container"
    style="background-color: #f3f3f3; padding-right: 60px; padding-left: 60px"
  >
    <div class="text-center">
      <h2 class="text-gray-900" style="margin-top: 100px">
        <span>БҮРТГЭЛИЙН АНКЕТ</span>
      </h2>
    </div>
    <div class="row justify-content-center">
      <div class="col-xl-8 col-lg-10 col-md-8">
        <div class="card o-hidden border-0 shadow-sm mt-4">
          <div class="card-body p-0">
            <div class="row">
              <div class="col-lg-12">
                <div class="p-5">
                  <div class="text-center">
                    <h1 class="h4 text-gray-900 mb-4">
                      <span>Xөтөлбөр сонголт</span>
                    </h1>
                  </div>
                  <form class="user">
                    <hr />

                    <div class="row">
                      <div class="col-md-6 col-sm-12">
                        <div class="form-group">
                          <label for="exampleFormControlSelect1"
                            >Мэргэжлийн зэрэг</label
                          >
                          <select class="form-control" v-model="student.degree">
                            <option
                              v-for="(degree, index) in degrees"
                              v-bind:key="degree.id"
                              v-bind:value="degree.ref"
                            >
                              {{ index + 1 }}. {{ degree.name }}
                            </option>
                          </select>
                        </div>
                      </div>
                      <div class="col-md-6 col-sm-12">
                        <div class="form-group">
                          <label for="exampleFormControlSelect1"
                            >Хөтөлбөр</label
                          >
                          <select
                            class="form-control"
                            v-model="student.program"
                          >
                            <option
                              v-for="(program, index) in allprograms"
                              v-bind:value="program.ref"
                            >
                              {{ index + 1 }}. {{ program.name }}
                            </option>
                          </select>
                        </div>
                      </div>
                    </div>

                    <!-- <div class="row">
                      <div class="col">
                        <div class="form-group">
                          <label for="exampleFormControlSelect1">Сургууль</label>
                          <select class="form-control" v-model="school" @change="schoolChanged">
                            <option
                              v-for="(school, index) in schools"
                              v-bind:key="school.id"
                              v-bind:value="school"
                            >{{index+1}}. {{school.data().name}}</option>
                          </select>
                        </div>
                      </div>
                      <div class="col" v-if="school!=null">
                        <div class="form-group">
                          <label for="exampleFormControlSelect1">Тэнхим</label>
                          <select class="form-control" v-model="department">
                            <option
                              v-for="(dep, index) in school.departments"
                              v-bind:key="dep.id"
                              v-bind:value="dep"
                            >{{index+1}}. {{dep.data().name}}</option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div class="form-group" v-if="department!=null">
                      <label for="exampleFormControlSelect1">Хөтөлбөр</label>
                      <select class="form-control" v-model="program">
                        <option
                          v-for="(pro, index) in department.programs"
                          v-bind:key="pro.id"
                          v-bind:value="pro"
                        >{{index+1}}. {{pro.data().name}}</option>
                      </select>
                    </div> -->
                    <div class="row">
                      <div class="col-md-6 col-sm-12 form-group">
                        <div class="radio">
                          <label>
                            <input
                              class="mr-2"
                              type="radio"
                              name="typegroup"
                              value="shift"
                              v-model="student.type"
                              v-bind:checked="
                                student.type && student.type == 'shift'
                                  ? 'checked'
                                  : ''
                              "
                            />Шилжиж ирсэн
                          </label>
                        </div>
                        <div class="radio">
                          <label>
                            <input
                              class="mr-2"
                              type="radio"
                              name="typegroup"
                              value="new"
                              v-model="student.type"
                              v-bind:checked="
                                student.type && student.type == 'new'
                                  ? 'checked'
                                  : ''
                              "
                            />Шинэ
                          </label>
                        </div>
                      </div>
                      <div class="col-md-6 col-sm-12 form-group">
                        <div class="form-group">
                          <label for="exampleFormControlSelect1"
                            >Элсэx семестр</label
                          >
                          <select class="form-control" v-model="semester">
                            <option
                              v-for="(s, index) in semesters"
                              v-bind:key="s.id"
                              v-bind:value="s"
                            >
                              {{ index + 1 }}. {{ s.data().title }}
                            </option>
                          </select>
                        </div>
                      </div>
                    </div>

                    <!-- <div class="row" v-if="program && courses && student">
                      <div class="col">
                        <div class="form-group">
                          <label for="exampleFormControlSelect1">Анги</label>
                          <select class="form-control" v-model="student.course">
                            <option v-for="course in courses" v-bind:value="course">{{course}}</option>
                          </select>
                        </div>
                      </div>
                      <div class="col">
                        <div class="form-group">
                          <label for="exampleFormControlSelect1">Бүлэг</label>
                          <select class="form-control" v-model="student.group">
                            <option v-for="group in groups" v-bind:value="group">{{group}}</option>
                          </select>
                        </div>
                      </div>
                    </div> -->
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xl-8 col-lg-10 col-md-8">
        <div class="card o-hidden border-0 shadow-sm">
          <div class="card-body p-0">
            <div class="row">
              <div class="col-lg-12">
                <div class="p-5">
                  <div class="text-center">
                    <h1 class="h4 text-gray-900 mb-4">
                      <span> Элсэгчийн xувийн мэдээлэл</span>
                    </h1>
                  </div>
                  <form class="user">
                    <div class="row">
                      <div class="col-md-6 col-sm-12 form-group">
                        <label>Ургийн овог</label>
                        <input
                          v-model.trim="student.urag"
                          type="text"
                          class="form-control"
                          id="urgiinovog"
                        />
                      </div>
                      <div class="col-md-6 col-sm-12 form-group">
                        <label>Яс үндэс</label>
                        <input
                          v-model.trim="student.yasundes"
                          type="text"
                          class="form-control"
                          id="yasundes"
                        />
                      </div>
                      <div class="col-md-6 col-sm-12 form-group">
                        <label>Нэр <span class="text-danger">*</span></label>
                        <input
                          v-model.trim="student.name"
                          type="text"
                          class="form-control"
                          id="exampleInputEmail"
                        />
                      </div>
                      <div class="col-md-6 col-sm-12form-group">
                        <label>Овог<span class="text-danger">*</span></label>
                        <input
                          v-model.trim="student.lastname"
                          type="text"
                          class="form-control"
                          id="exampleInputEmail"
                        />
                      </div>

                      <div class="col-md-6 col-sm-12 form-group">
                        <div class="radio">
                          <label>
                            <input
                              class="mr-2"
                              type="radio"
                              name="gendergroup"
                              value="male"
                              v-model="student.gender"
                              v-bind:checked="
                                student.gender && student.gender == 'male'
                                  ? 'checked'
                                  : ''
                              "
                            />Эр
                          </label>
                        </div>
                        <div class="radio">
                          <label>
                            <input
                              class="mr-2"
                              type="radio"
                              name="gendergroup"
                              value="female"
                              v-model="student.gender"
                              v-bind:checked="
                                student.gender && student.gender == 'female'
                                  ? 'checked'
                                  : ''
                              "
                            />Эм
                          </label>
                        </div>
                      </div>
                      <div class="col-md-6 col-sm-12 form-group">
                        <label
                          >Регистрийн дугаар<span class="text-danger"
                            >*</span
                          ></label
                        >
                        <input
                          v-model.trim="student.register"
                          type="text"
                          class="form-control"
                        />
                      </div>
                    </div>
                    <div class="row">
                      <!-- <div class="col-md-6 col-sm-12 form-group">
                        <label>Оюутны код</label>
                        <input
                          v-model.trim="student.code"
                          type="text"
                          class="form-control"
                        />
                      </div> -->
                    </div>
                    <div class="row">
                      <div class="col-md-6 col-sm-12 form-group">
                        <label
                          >Утасны дугаар 1<span class="text-danger"
                            >*</span
                          ></label
                        >
                        <input
                          v-model.trim="student.phone"
                          type="text"
                          class="form-control"
                        />
                      </div>

                      <div class="col-md-6 col-sm-12 form-group">
                        <label>Имэйл</label>
                        <input
                          v-model.trim="student.email"
                          type="text"
                          class="form-control"
                        />
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-6 col-sm-12 form-group">
                        <label
                          >Онцгой шаардлага гарвал харилцах хүний нэр</label
                        >
                        <input
                          v-model.trim="student.name2"
                          type="text"
                          class="form-control"
                          id="exampleInputEmail"
                        />
                      </div>

                      <div class="col-md-6 col-sm-12 form-group">
                        <label>Утасны дугаар 2</label>
                        <input
                          v-model.trim="student.phone2"
                          type="text"
                          class="form-control"
                        />
                      </div>
                    </div>
                    <hr />
                    <div v-if="student.birth">
                      <div class="row">
                        <div class="col">
                          <div class="form-group">
                            <label for="exampleFormControlSelect1"
                              >Төрсөн он</label
                            >
                            <select
                              class="form-control"
                              v-model="student.birth.year"
                            >
                              <option v-for="year in years" v-bind:value="year">
                                {{ year }} он
                              </option>
                            </select>
                          </div>
                        </div>
                        <div class="col">
                          <div class="form-group">
                            <label for="exampleFormControlSelect1"
                              >Төрсөн сар</label
                            >
                            <select
                              class="form-control"
                              v-model="student.birth.month"
                            >
                              <option
                                v-for="month in months"
                                v-bind:value="month"
                              >
                                {{ month }} сар
                              </option>
                            </select>
                          </div>
                        </div>
                        <div class="col">
                          <div class="form-group">
                            <label for="exampleFormControlSelect1"
                              >Төрсөн өдөр</label
                            >
                            <select
                              class="form-control"
                              v-model="student.birth.day"
                            >
                              <option v-for="day in days" v-bind:value="day">
                                {{ day }}
                              </option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                    <hr />
                    <div class="text-center font-weight-bold mb-4">
                      Ажлын газрын хаяг
                    </div>
                    <div class="row">
                      <div class="col-md-6 col-sm-12">
                        <div class="form-group">
                          <label>Албан тушаал</label>
                          <input
                            v-model.trim="student.albantushaal"
                            type="text"
                            class="form-control"
                          />
                        </div>
                      </div>
                      <div class="col-md-6 col-sm-12">
                        <div class="form-group">
                          <label>Байгууллагын нэр</label>
                          <input
                            v-model.trim="student.baiguullaga"
                            type="text"
                            class="form-control"
                          />
                        </div>
                      </div>
                    </div>
                    <div v-if="student.iaddress">
                      <div class="text-center font-weight-bold mt-4">
                        Оршин суугаа хаяг
                      </div>
                      <div class="row">
                        <div class="col">
                          <div class="form-group">
                            <label for="exampleFormControlSelect1">Хот:</label>
                            <select class="form-control" v-model="city">
                              <option
                                v-for="(school, index) in cities"
                                v-bind:key="school.id"
                                v-bind:value="school"
                              >
                                {{ index + 1 }}. {{ school.data().name }}
                              </option>
                            </select>
                          </div>
                        </div>
                        <div class="col" v-if="city">
                          <div class="form-group">
                            <label for="exampleFormControlSelect1"
                              >Дүүрэг/Сум:</label
                            >
                            <select class="form-control" v-model="district">
                              <option
                                v-for="(dep, index) in city.districts"
                                v-bind:key="dep.id"
                                v-bind:value="dep"
                              >
                                {{ index + 1 }}. {{ dep.data().name }}
                              </option>
                            </select>
                          </div>
                        </div>
                      </div>

                      <div class="row" v-if="district">
                        <div class="col">
                          <div class="form-group">
                            <label for="exampleFormControlSelect1"
                              >Хороо /баг/:</label
                            >
                            <input
                              v-model.trim="student.iaddress.horoo"
                              type="text"
                              class="form-control"
                            />
                          </div>
                        </div>
                        <div class="col">
                          <div class="form-group">
                            <label for="exampleFormControlSelect1"
                              >Байшин/Гудам:</label
                            >
                            <input
                              v-model.trim="student.iaddress.building"
                              type="text"
                              class="form-control"
                            />
                          </div>
                        </div>
                        <div class="col">
                          <div class="form-group">
                            <label for="exampleFormControlSelect1">Тоот:</label>
                            <input
                              v-model.trim="student.iaddress.entrynumber"
                              type="text"
                              class="form-control"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- This is the second part of form  -->

      <div class="col-xl-8 col-lg-10 col-md-8">
        <div class="card o-hidden border-0 shadow-sm">
          <div class="card-body p-0">
            <div class="row">
              <div class="col-lg-12">
                <div class="p-5">
                  <div class="text-center">
                    <h1 class="h4 text-gray-900 mb-4">
                      <span>Боловсролын мэдээлэл </span>
                    </h1>
                  </div>
                  <form class="user">
                    <hr />
                    <div class="row">
                      <div class="col-md-6 col-sm-12">
                        <div class="form-group">
                          <label>Төгссөн сургууль</label>
                          <input
                            v-model.trim="student.past_school"
                            type="text"
                            class="form-control"
                          />
                        </div>
                      </div>
                      <div class="col-md-4 col-sm-12">
                        <div class="form-group">
                          <label>Сургуулийн байршил (улс)</label>
                          <input
                            v-model.trim="student.past_school_country"
                            type="text"
                            class="form-control"
                          />
                        </div>
                      </div>
                      <div class="col-md-2 col-sm-12">
                        <div class="form-group">
                          <label>Төгссөн он</label>
                          <input
                            v-model.trim="student.past_gradyear"
                            type="text"
                            class="form-control"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-6 col-sm-12">
                        <div class="form-group">
                          <label
                            >Дипломын дугаар
                            <span
                              class="text-danger"
                              v-if="
                                student.degree != undefined &&
                                student.degree != null &&
                                student.degree.id == 'master'
                              "
                            >
                              (Бакалаврын мэргэжил)</span
                            ></label
                          >
                          <input
                            v-model.trim="student.past_school_diplomaid"
                            type="text"
                            class="form-control"
                          />
                        </div>
                      </div>
                      <div class="col-md-4 col-sm-12">
                        <div class="form-group">
                          <label>Мэргэжил</label>
                          <input
                            v-model.trim="student.past_school_profession"
                            type="text"
                            class="form-control"
                          />
                        </div>
                      </div>
                      <div class="col-md-2 col-sm-2">
                        <div class="form-group">
                          <label>Голч (1-5)</label>
                          <input
                            v-model.number="student.past_score"
                            type="number"
                            class="form-control"
                            min="1"
                            max="5"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-12 col-sm-12">
                        <div class="form-group">
                          <label>Xамгаалсан чиглэл </label>
                          <input
                            v-model.trim="student.past_school_diplomaid_topic"
                            type="text"
                            class="form-control"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-4">
                        <p @click="_uploadFile">File upload</p>
                      </div>
                    </div>
                    <div class="alert alert-warning mt-4" role="alert">
                      *Докторын сургалтанд суралцаx бол магистрын дипломны
                      мэдээллээ бөглөнө үү.
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xl-8 col-lg-10 col-md-8">
        <div class="card o-hidden border-0 shadow-sm">
          <div class="card-body p-0">
            <div class="row">
              <div class="col-lg-12">
                <div class="p-5">
                  <div class="text-center">
                    <h1 class="h4 text-gray-900 mb-4">
                      <span>Бусад мэдээлэл</span>
                    </h1>
                  </div>
                  <form class="user">
                    <hr />
                    <div class="text-start font-weight-bold mb-4">
                      Та манай сургуулийн талаарх мэдээллийг хаанаас авсан бэ?
                    </div>
                    <div class="row">
                      <div
                        class="col-md-4 col-sm-12 form-group nopaddingmargin"
                      >
                        <div class="radio">
                          <label>
                            <input
                              class="mr-2"
                              type="radio"
                              name="wheregetinfogroup"
                              value="fromGraduatedstudent"
                              v-model="student.wheregetinfo"
                              v-bind:checked="
                                student.wheregetinfo &&
                                student.wheregetinfo == 'fromGraduatedstudent'
                                  ? 'checked'
                                  : ''
                              "
                            />Төгсөгчид
                          </label>
                        </div>
                      </div>
                      <div class="col-md-4 col-sm-12 form-group">
                        <div class="radio">
                          <label>
                            <input
                              class="mr-2"
                              type="radio"
                              name="wheregetinfogroup"
                              value="fromStudyingstudents"
                              v-model="student.wheregetinfo"
                              v-bind:checked="
                                student.wheregetinfo &&
                                student.wheregetinfo == 'fromStudyingstudents'
                                  ? 'checked'
                                  : ''
                              "
                            />Суралцагчид
                          </label>
                        </div>
                      </div>
                      <div class="col-md-4 col-sm-12 form-group">
                        <div class="radio">
                          <label>
                            <input
                              class="mr-2"
                              type="radio"
                              name="wheregetinfogroup"
                              value="fromWebsite"
                              v-model="student.wheregetinfo"
                              v-bind:checked="
                                student.wheregetinfo &&
                                student.wheregetinfo == 'fromWebsite'
                                  ? 'checked'
                                  : ''
                              "
                            />Веб сайт
                          </label>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-4 col-sm-12 form-group">
                        <div class="radio">
                          <label>
                            <input
                              class="mr-2"
                              type="radio"
                              name="wheregetinfogroup"
                              value="fromnewspaper"
                              v-model="student.wheregetinfo"
                              v-bind:checked="
                                student.wheregetinfo &&
                                student.wheregetinfo == 'fromnewspaper'
                                  ? 'checked'
                                  : ''
                              "
                            />Сонин
                          </label>
                        </div>
                      </div>
                      <div class="col-md-4 col-sm-12 form-group">
                        <div class="radio">
                          <label>
                            <input
                              class="mr-2"
                              type="radio"
                              name="wheregetinfogroup"
                              value="fromTV"
                              v-model="student.wheregetinfo"
                              v-bind:checked="
                                student.wheregetinfo &&
                                student.wheregetinfo == 'fromTV'
                                  ? 'checked'
                                  : ''
                              "
                            />Телевиз
                          </label>
                        </div>
                      </div>
                      <div class="col-md-4 col-sm-12 form-group">
                        <div class="radio">
                          <label>
                            <input
                              class="mr-2"
                              type="radio"
                              name="wheregetinfogroup"
                              value="fromOthermedia"
                              v-model="student.wheregetinfo"
                              v-bind:checked="
                                student.wheregetinfo &&
                                student.wheregetinfo == 'fromOthermedia'
                                  ? 'checked'
                                  : ''
                              "
                            />Бусад
                          </label>
                        </div>
                      </div>
                    </div>

                    <div class="text-start font-weight-bold my-4">
                      Сургалтын төлбөр төлөх хэлбэр
                    </div>
                    <div class="row">
                      <div class="col-md-4 col-sm-12 form-group">
                        <div class="radio">
                          <label>
                            <input
                              class="mr-2"
                              type="radio"
                              name="paymentTutionGroup"
                              value="paymentFromStateFoundation"
                              v-model="student.paymentTution"
                              v-bind:checked="
                                student.paymentTution &&
                                student.paymentTution ==
                                  'paymentFromStateFoundation'
                                  ? 'checked'
                                  : ''
                              "
                            />Төрийн сан
                          </label>
                        </div>
                      </div>
                      <div class="col-md-4 col-sm-12 form-group">
                        <div class="radio">
                          <label>
                            <input
                              class="mr-2"
                              type="radio"
                              name="paymentTutionGroup"
                              value="paymentFromOrga"
                              v-model="student.paymentTution"
                              v-bind:checked="
                                student.paymentTution &&
                                student.paymentTution == 'paymentFromOrga'
                                  ? 'checked'
                                  : ''
                              "
                            />Байгууллага
                          </label>
                        </div>
                      </div>

                      <div class="col-md-4 col-sm-12 form-group">
                        <div class="radio">
                          <label>
                            <input
                              class="mr-2"
                              type="radio"
                              name="paymentTutionGroup"
                              value="paymentFromSupport"
                              v-model="student.paymentTution"
                              v-bind:checked="
                                student.paymentTution &&
                                student.paymentTution == 'paymentFromSupport'
                                  ? 'checked'
                                  : ''
                              "
                            />Гадаадын байгууллагын тэтгэлэг
                          </label>
                        </div>
                      </div>

                      <div class="col-md-4 col-sm-12 form-group">
                        <div class="radio">
                          <label>
                            <input
                              class="mr-2"
                              type="radio"
                              name="paymentTutionGroup"
                              value="onme"
                              v-model="student.paymentTution"
                              v-bind:checked="
                                student.paymentTution &&
                                student.paymentTution == 'onme'
                                  ? 'checked'
                                  : ''
                              "
                            />Хувиараа
                          </label>
                        </div>
                      </div>

                      <div class="col-md-4 col-sm-12 form-group">
                        <div class="radio">
                          <label>
                            <input
                              class="mr-2"
                              type="radio"
                              name="paymentTutionGroup"
                              value="paymentOthers"
                              v-model="student.paymentTution"
                              v-bind:checked="
                                student.paymentTution &&
                                student.paymentTution == 'paymentOthers'
                                  ? 'checked'
                                  : ''
                              "
                            />Бусад
                          </label>
                        </div>
                      </div>
                    </div>

                    <hr />
                    <div class="row">
                      <div class="col-md-12 col-sm-12 form-group mt-4">
                        <label
                          >Өргөдөл (суралцах шалтгаан, судалгааны чиглэлээ бичнэ
                          үү)
                        </label>
                        <textarea
                          v-model.trim="student.additionalinfo"
                          type="text"
                          class="form-control"
                        />
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-xl-10 col-lg-12 col-md-9" style="margin-bottom: 100px">
        <div class="row p-2">
          <hr />
          <div class="row justify-content-center">
            <div class="col-md-6">
              <div @click="save" class="btn btn-danger" style="display: block">
                ИЛГЭЭX
              </div>
            </div>
            <!-- <div class="text-center col">
              <a class="small" href="#" @click="$router.back()">Буцах</a>
            </div>
            <div class="col">
              <div
                v-if="loading && loading == true"
                class="spinner-border"
                role="status"
              >
                <span class="sr-only">Loading...</span>
              </div>
              <div v-else @click="save" class="btn btn-primary">Хадгалах</div>
            </div> -->
          </div>
          <hr />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const fb = require("../firebaseConfig.js");
export default {
  name: "PreStudentAddGradedu",
  data() {
    return {
      student: {
        degree: null,
        urag: null,
        yasundes: null,
        name: null,
        lastname: null,
        phone: null,
        phone2: null,
        code: null,
        email: null,
        address: null,
        register: null,
        birth: {
          year: null,
          month: null,
          day: null,
        },
        iaddress: {
          city: null,
          district: null,
          horoo: null,
          building: null,
          entrynumber: null,
        },
        preschool: {
          city: null,
          district: null,
          schoolname: null,
        },
        gender: null,
        type: null,
        entry: {
          semester: null,
        },
        past_school: null,
        past_school_country: null,
        past_gradyear: null,
        past_school_diplomaid: null,
        past_school_profession: null,
        past_score: null,
        albantushaal: null,
        baiguullaga: null,
      },
      performingRequest: false,
      schools: [],
      school: null,
      department: null,
      program: null,
      years: [],
      months: [],
      days: [],
      cities: [],
      city: null,
      district: null,
      city1: null,
      district1: null,
      semesters: [],
      semester: null,
      courses: [1, 2, 3, 4, 5, 6],
      groups: ["A", "B", "C", "D"],
      degrees: [],
      allprograms: [],
      loading: false,
    };
  },
  watch: {
    "student.degree": function (val) {
      if (val) {
        this._getAllPrograms(val);
      }
    },
  },
  methods: {
    _uploadFile() {
      this.$router.push({
        name: "ImageAdd",
        params: {
          objectPath:
            "/tmps/JtIgYjQi4OvrNuJ3gnB9"
        },
      });
    },

    async save() {
      if (
        this.student != null &&
        this.student.name != "" &&
        this.student.program &&
        this.student.register
      ) {
        if (
          this.student.id != null &&
          this.student.id != "" &&
          this.student.id != "new"
        ) {
          this.student.modified = fb.usersCollection.doc(
            this.$store.getters.currentUser.uid
          );
          this.student.modifiedAt = new Date();
          // if (this.school != null)
          //   this.student.school = this.school.ref;
          // if (this.department != null)
          //   this.student.department = this.department.ref;
          if (this.student.program != null) {
            if (
              this.student.program.parent &&
              this.student.program.parent.parent
            ) {
              this.student.department = this.student.program.parent.parent;
              if (
                this.student.department.parent &&
                this.student.department.parent.parent
              ) {
                this.student.school = this.student.department.parent.parent;
              }
            }
          }

          if (this.city) {
            this.student.iaddress.cityName = this.city.data().name;
            this.student.iaddress.city = this.city.ref;
          }
          if (this.district) {
            this.student.iaddress.districtName = this.district.data().name;
            this.student.iaddress.district = this.district.ref;
          }

          if (this.city1) {
            this.student.preschool.cityName = this.city1.data().name;
            this.student.preschool.city = this.city1.ref;
          }
          if (this.district1) {
            this.student.preschool.districtName = this.district1.data().name;
            this.student.preschool.district = this.district1.ref;
          }
          if (this.semester) {
            this.student.entry.semester = this.semester.ref;
            this.student.entry.data = this.semester.data().date
              ? this.semester.data().date
              : null;
          }
          fb.db
            .collection("prestudents")
            .doc(this.student.id)
            .set(this.student);
          this.loading = false;

          this.$router.back();
        } else {
          this.loading = true;
          var doc = await fb.db.collection("prestudents").doc().get();

          if (doc.exists) {
            alert(" кодтой оюутан бүртгэгдсэн байна.");
            this.loading = fale;
            return;
          } else {
            // this.student.code=this.student.code.toLowerCase();
            if (this.student.register == null) return; //TODO!!!!
            this.student.register = this.student.register.toLowerCase();
            var sts = await fb.db
              .collection("prestudents")
              .where("register", "==", this.student.register)
              .get();
            if (sts.empty == true) {
              if (
                this.$store.getters.currentUser &&
                this.$store.getters.currentUser.uid
              )
                this.student.created = fb.usersCollection.doc(
                  this.$store.getters.currentUser.uid
                );
              this.student.createdAt = new Date();
              if (this.student.program != null) {
                this.student.program.update({
                  numberOfPreStudents: fb.firestore.FieldValue.increment(1),
                });
                if (
                  this.student.program.parent &&
                  this.student.program.parent.parent
                ) {
                  this.student.department = this.student.program.parent.parent;
                  this.student.department.update({
                    numberOfPreStudents: fb.firestore.FieldValue.increment(1),
                  });
                  if (
                    this.student.department.parent &&
                    this.student.department.parent.parent
                  ) {
                    this.student.school = this.student.department.parent.parent;
                    this.student.school.update({
                      numberOfPreStudents: fb.firestore.FieldValue.increment(1),
                    });
                  }
                }
              }
              if (this.city) {
                this.student.iaddress.cityName = this.city.data().name;
                this.student.iaddress.city = this.city.ref;
              }
              if (this.district) {
                this.student.iaddress.districtName = this.district.data().name;
                this.student.iaddress.district = this.district.ref;
              }

              if (this.city1) {
                this.student.preschool.cityName = this.city1.data().name;
                this.student.preschool.city = this.city1.ref;
              }
              if (this.district1) {
                this.student.preschool.districtName =
                  this.district1.data().name;
                this.student.preschool.district = this.district1.ref;
              }
              if (this.semester) {
                this.student.entry.semester = this.semester.ref;
                this.student.entry.data = this.semester.data().date
                  ? this.semester.data().date
                  : null;
              }
              await doc.ref.set(this.student);
              this.loading = false;
              alert("Таны хүсэлт амжилттай илгээгдлээ.");
              this.$router.back();
            } else {
              this.loading = false;
              alert(
                this.student.register + " регистртэй оюутан бүртгэгдсэн байна"
              );
            }
          }
        }
      } else
        alert(
          "Та оюутны нэр, овог, регистр, хөтөлбөр гэх мэт шаардлагатай мэдээллийг оруулна уу."
        );
    },
    setStudent() {
      this.student = {
        degree: null,
        urag: null,
        yasundes: null,
        name: null,
        lastname: null,
        phone: null,
        phone2: null,
        code: null,
        email: null,
        address: null,
        register: null,
        birth: {
          year: null,
          month: null,
          day: null,
        },
        iaddress: {
          city: null,
          district: null,
          horoo: null,
          building: null,
          entrynumber: null,
        },
        preschool: {
          city: null,
          district: null,
          schoolname: null,
        },
        gender: null,
        type: null,
        entry: {
          semester: null,
        },
        past_school: null,
        past_school_country: null,
        past_gradyear: null,
        past_school_diplomaid: null,
        past_school_profession: null,
        past_score: null,
        albantushaal: null,
        baiguullaga: null,
      };
    },

    remove(index, array) {
      if (array != null && array.length > 0) array.splice(index, 1);
    },
    _getSemester() {
      fb.db
        .collection("semester")
        .orderBy("index")
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((schoolData) => {
            this.semesters.push(schoolData);
            if (
              this.student.entry != null &&
              this.student.entry.semester &&
              this.student.entry.semester.path == schoolData.ref.path
            ) {
              this.semester = schoolData;
            }
          });
        });

      fb.db
        .collection("degrees")
        .orderBy("index")
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((schoolData) => {
            if (schoolData.exists) {
              let degree = schoolData.data();
              degree.id = schoolData.id;
              degree.ref = schoolData.ref;
              this.degrees.push(degree);
            }
          });
        });
    },
    _getSchools() {
      fb.db
        .collection("schools")
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((schoolData) => {
            this._getDepartments(schoolData.id, schoolData);
            this.schools.push(schoolData);
            if (
              this.student.school != null &&
              this.student.school.path == schoolData.ref.path
            ) {
              this.school = schoolData;
            }
          });
        })
        .catch(function (error) {
          console.log("Error getting documents: ", error);
        });
    },
    _getDepartments(schoolId, schoolData) {
      schoolData.ref
        .collection("departments")
        .get()
        .then((querySnapshot) => {
          let deps = [];
          querySnapshot.forEach((depdata) => {
            this._getPros(depdata);
            deps.push(depdata);
            if (
              this.student.department != null &&
              this.student.department.path == depdata.ref.path
            ) {
              this.department = depdata;
            }
          });
          schoolData.departments = deps;
        })
        .catch(function (error) {
          console.log("Error getting documents: ", error);
        });
    },
    _getPros(depdata) {
      depdata.ref
        .collection("programs")
        .get()
        .then((querySnapshot) => {
          let pros = [];
          querySnapshot.forEach((prodata) => {
            pros.push(prodata);
            if (
              this.student.program != null &&
              this.student.program.path == prodata.ref.path
            ) {
              this.program = prodata;
            }
          });
          depdata.programs = pros;
        })
        .catch(function (error) {
          console.log("Error getting documents: ", error);
        });
    },
    async _getAllPrograms(degreeRef) {
      this.allprograms = [];
      var tmp = [];
      // var schoolSnapshot= await fb.db.collection("schools").get();
      // if(schoolSnapshot && !schoolSnapshot.empty){
      //   for(const schoolDoc of schoolSnapshot.docs){
      //     var departmentSnapshot=await schoolDoc.ref.collection("departments").get();
      //     if(departmentSnapshot && !departmentSnapshot.empty){
      //       for(const depDoc of departmentSnapshot.docs){
      var programSnapshot = await fb.db
        .collectionGroup("programs")
        .where("degree", "==", degreeRef)
        .get();
      if (programSnapshot && !programSnapshot.empty) {
        for (const proDoc of programSnapshot.docs) {
          let object = proDoc.data();
          object.id = proDoc.id;
          object.ref = proDoc.ref;
          tmp.push(object);
        }
      }
      //     }
      //   }
      // }
      // }
      this.allprograms = tmp;
    },

    _getcities() {
      fb.db
        .collection("cities")
        .orderBy("index")
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((schoolData) => {
            this._getDistricts(schoolData.id, schoolData);
            this.cities.push(schoolData);
            if (
              this.student.iaddress &&
              this.student.iaddress.city &&
              this.student.iaddress.city.path == schoolData.ref.path
            ) {
              this.city = schoolData;
            }
            if (
              this.student.preschool &&
              this.student.preschool.city &&
              this.student.preschool.city.path == schoolData.ref.path
            ) {
              this.city1 = schoolData;
            }
          });
        })
        .catch(function (error) {
          console.log("Error getting documents: ", error);
        });
    },
    _getDistricts(schoolId, schoolData) {
      schoolData.ref
        .collection("districts")
        .orderBy("index")
        .get()
        .then((querySnapshot) => {
          let deps = [];
          querySnapshot.forEach((depdata) => {
            this._getPros(depdata);
            deps.push(depdata);
            if (
              this.student.iaddress &&
              this.student.iaddress.district &&
              this.student.iaddress.district.path == depdata.ref.path
            ) {
              this.district = depdata;
            }
            if (
              this.student.preschool &&
              this.student.preschool.district &&
              this.student.preschool.district.path == depdata.ref.path
            ) {
              this.district1 = depdata;
            }
          });
          schoolData.districts = deps;
        })
        .catch(function (error) {
          console.log("Error getting documents: ", error);
        });
    },
    schoolChanged() {
      this.department = null;
      this.program = null;
    },
    _getStudent() {
      if (
        this.studentId != null &&
        this.studentId != "" &&
        this.studentId != "new"
      ) {
        fb.db
          .collection("prestudents")
          .doc(this.studentId)
          .get()
          .then((studentData) => {
            let object = studentData.data();
            object.id = studentData.id;
            this.student = object;
            if (!this.student.birth) {
              this.student.birth = {
                year: null,
                month: null,
                day: null,
              };
            }
            if (!this.student.iaddress) {
              this.student.iaddress = {
                city: null,
                district: null,
                horoo: null,
                building: null,
                entrynumber: null,
              };
            }
            if (!this.student.preschool) {
              this.student.preschool = {
                city: null,
                district: null,
                schoolname: null,
              };
            }
            if (!this.student.gender) this.student.gender = null;
            if (!this.student.type) this.student.type = null;
            if (!this.student.entry) {
              this.student.entry = {
                semester: null,
              };
            }
            // if (!this.student.course) this.student.course = null;
            // if (!this.student.group) this.student.group = null;

            this._getcities();
          });
      } else this._getcities();
      this._getSchools();
      this._getSemester();
    },
  },
  props: {
    studentId: {
      required: false,
    },
  },
  created() {
    for (var i = 1970; i <= 2020; i++) {
      this.years.push(i);
    }
    for (var i = 1; i <= 12; i++) {
      this.months.push(i);
    }
    for (var i = 1; i <= 31; i++) {
      this.days.push(i);
    }
    this._getStudent();
  },
};
</script>

<style>
.card {
  padding: 0;
}
.form-group {
  margin-top: 0px;
  margin-bottom: 0px;
  padding-top: 0px;
}
</style>